import { PositionReward } from "@silo/types";
import { Order } from "effect";

export const byAprAsc = Order.mapInput(
  Order.bigint,
  (reward: PositionReward) => reward.apr
);

export const byAprDesc = Order.reverse(byAprAsc);
